import { ActionSheetIOS, Platform } from 'react-native';

export type ActionSheetOption = {
  label: string;
  onSelect: () => void;
  destructive?: boolean;
};

export type ActionSheetConfig = {
  title?: string;
  message?: string;
  cancelLabel: string;
  options: ActionSheetOption[];
};

type ActionSheetHostApi = {
  show: (config: ActionSheetConfig) => void;
};

let action_sheet_host: ActionSheetHostApi | null = null;

/** Registers the Android bottom-sheet host (mounted once in `AppNavigator`). */
export function registerActionSheetHost(host: ActionSheetHostApi | null): void {
  action_sheet_host = host;
}

/**
 * Cross-platform action sheet: iOS `ActionSheetIOS`; Android frosted bottom sheet via registered host.
 */
export function showActionSheet(config: ActionSheetConfig): void {
  if (Platform.OS === 'ios') {
    const labels = [config.cancelLabel, ...config.options.map(o => o.label)];
    const destructive_index = config.options.findIndex(o => o.destructive);
    ActionSheetIOS.showActionSheetWithOptions(
      {
        title: config.title,
        message: config.message,
        options: labels,
        cancelButtonIndex: 0,
        destructiveButtonIndex: destructive_index >= 0 ? destructive_index + 1 : undefined,
      },
      button_index => {
        if (button_index == null || button_index <= 0) {
          return;
        }
        config.options[button_index - 1]?.onSelect();
      },
    );
    return;
  }

  action_sheet_host?.show(config);
}
